import script from "./Questions.vue?vue&type=script&setup=true&lang=js"
export * from "./Questions.vue?vue&type=script&setup=true&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=40c078ce&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c078ce"]])

export default __exports__